import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Link, useParams } from '@tanstack/react-router';
import { EmptyState } from '@/components/states';
import { Button } from '@/components/ui/button';

export function PlayerNotFound() {
  const { playerId } = useParams({ strict: false });
  return (
    <EmptyState
      icon={<MagnifyingGlassIcon />}
      title="Player not found"
      description={
        playerId ? `There's no player #${playerId} you can see. Check the id, or search the players list.` : undefined
      }
      action={
        <Button variant="outline" asChild>
          <Link to="/players">Back to players</Link>
        </Button>
      }
    />
  );
}
